/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />

module App.Common.Directives {
	'use strict';

	export class MustBePostcode extends ValidatorBase {

		public static $inject = ['app.common.services.globalSettingsService'];

		constructor(private globalSettings: Common.Services.GlobalSettingsService) {
			super();
		}

		public name = 'must-be-postcode';

		public isValid = (args: Directives.ValidateArgs) => {
            return this.globalSettings.postcodeRegexp.test(args.viewValue());
		};

		public resolveMessage = (): string => {
			return 'Please enter a valid postcode';
		};
	}

	factory.$inject = ['app.common.services.globalSettingsService'];

	function factory(globalSettings: Common.Services.GlobalSettingsService) {
        return new MustBePostcode(globalSettings);
	}

	angular
		.module('app.common.directives')
		.directive('mustBePostcode', factory);

}